<template>
    <div>
        <Header backButton></Header>
        <div class="inscription">
            <img class="logo" alt="Quest Me logo" src="../assets/logo.png">
            <form method="post" @submit="send" class="indexUp">
                <div class="contenu pt-12">
                    <span class="open-book">
                        <p class="text-2xl leading-normal">
                            Dans votre monde, vous vous présentez comme
                            <input
                                class="my-5 w60 mr-1"
                                name="pseudo"
                                v-model="pseudo"
                                placeholder="pseudo"
                                type="text"
                                required
                            >
                        </p>
                    </span>
                    <p class="text-2xl leading-normal">
                        Seigneur de
                        <input
                            class="my-5 w60"
                            name="location"
                            v-model="location"
                            placeholder="location"
                            type="text"
                            required
                        >
                    </p>
                    <p class="text-2xl leading-normal">
                        Et, chacun sait que
                        <textarea
                            name="description"
                            id="description"
                            cols="28"
                            rows="6"
                            placeholder="description"
                            v-model="description"
                            required
                        ></textarea>
                    </p>
                    <p class="text-2xl mt-8s leading-normal text-right">Mais en vrai ...</p>
                </div>
                <Submit></Submit>
            </form>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Submit from "@/components/inputs/Submit.vue";

export default {
    name: "inscription-private",
    components: {
        Submit,
        Header
    },
    data() {
        return {
            pseudo: "",
            sexe: "",
            location: "",
            description: "",
            error: null
        };
    },
    computed: {
        userID: {
            get() {
                return this.$store.getters.currentAppData.userID;
            },
            set(value) {
                this.$store.dispatch("storeUser", {
                    user: value
                });
            }
        }
    },
    methods: {
        send(e) {
            e.preventDefault();
            this.axios
                .put("/api/users/" + this.userID + "/inscription/private", {
                    pseudo: this.pseudo,
                    location: this.location,
                    description: this.description
                })
                .then(response => {
                    if (response.status == 200) {
                        this.$router.push("/inscription-public");
                    }
                })
                .catch(errors => {
                    this.error = errors.data;
                });
        }
    }
};
</script>

<style scoped lang="scss">
.inscription {
    height: 100%;
    margin-top: 60px;

    .logo {
        position: fixed;
        top: -50px;
        left: -65px;
        width: 80%;
        opacity: 0.3;
    }
    .contenu {
        margin: 0 34px;
        text-align: left;
    }
}

.open-book {
    p:first-of-type {
        text-indent: 0;
    }

    p:first-of-type:first-letter {
        float: left;
        font: 700 3em/0.65 "sunshiney", sans-serif;
        padding: 0.15em 0.15em 0 0;
        text-transform: uppercase;
    }
}
.w60 {
    width: 60%;
}
</style>